export default {
    AIR_TO_LIQUID_COOLING: "AIR_TO_LIQUID_COOLING",
    SYSTEMIC_LIQUID_COOLING: "SYSTEMIC_LIQUID_COOLING",
    RDHX_AIR_COOLED: "RDHX_AIR_COOLED",
    IDC_LIQUID_COOLING: "IDC_LIQUID_COOLING",
    AIGC_INFRASTRUCTURE: "AIGC_INFRASTRUCTURE",
    CONTACT_US: "CONTACT_US",
    L2A_PRODUCT: "L2A_PRODUCT",
    L2L_PRODUCT: "L2L_PRODUCT",
    RDHx_PRODUCT: "RDHx_PRODUCT",
    OTHERS_PRODUCT: "OTHERS_PRODUCT",
}